import React from "react";
import MediaViewer from "./MediaViewer";

const AnswersList = ({ answers, click, handleOpenAll, t, REACT_APP_BUCKET_BASE_URL }) => {
  return (
    <div className="flex h-[360px] pl-10 overflow-y-auto scrollbarBlack">
      <ul className="list-decimal w-full">
        <div className="w-full grid justify-items-end">
          {answers !== null && answers.length > 0 ? (
            <button
              id="expAll"
              className="col left rounded-lg bg-[black] font-[Gravity] w-[150px] text-[white] my-1 mx-1"
              onClick={(event) => handleOpenAll(event)}
            >
              {!click ? t("monitoringTrips.see") : t("monitoringTrips.hidden")}
            </button>
          ) : (
            <div></div>
          )}
        </div>
        {answers !== null && answers.length > 0 ? (
          answers.map((item, index) =>
            item.response || item.responseFile ? (
              <details 
                key={index} 
                className="open:bg-amber-200 duration-300 border border-gray-300"
              >
                <summary className="bg-inherit px-5 py-3 cursor-pointer font-[Gravity]">
                  {item.question}{" "}
                  {item.isIncident ? (
                    <span className="text-[#222] opacity-[.7]">Incidencia</span>
                  ) : ""}
                </summary>
                <div className="bg-white px-5 py-3 border border-gray-300 text-md font-light">
                  <MediaViewer
                    response={item.response}
                    responseFile={item.responseFile}
                    responsedAt={item.responsedAt}
                    isVideo={item.isVideo}
                    signedUrl={item.signedUrl}
                    REACT_APP_BUCKET_BASE_URL={REACT_APP_BUCKET_BASE_URL}
                  />
                </div>
              </details>
            ) : (
              <div key={index} className="px-5 py-3 border border-gray-300 font-light">
                <p className="font-[Gravity] text-md">{item.question}</p>
              </div>
            )
          )
        ) : (
          <p className="font-[Gravity] text-md mt-10 ml-4">
            {t("modalDetailTrip.answers")}
          </p>
        )}
      </ul>
    </div>
  );
};

export default AnswersList;
